import React from "react";
import UsersEmail from "./UsersEmail";

const ApplicantEmails=()=>{
  return <UsersEmail type="recruiter" typeName="Recruiters" />
}

export default ApplicantEmails;